<div class="container">
  <div class="tab-nav">
    <div class="tab-nav__left">
      <div
        class="tab-nav__left__items"
        cdkDropListOrientation="horizontal"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        @for (tab of tabs; track $index) {
          <div
            class="tab-nav__left__items__edit-item cursor-pointer"
            cdkDragBoundary=".tab-nav__left__items__item"
            cdkDragLockAxis="x"
            cdkDragFreeDragPosition=""
            (click)="switchTab(tab)"
            cdkDrag
            [class.active]="tab.id === currentTab.id"
          >
            <mat-icon cdkDragHandle class="drag-icon" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
            <span
              #tabName
              [class.cursor-text]="tabName.contentEditable == 'true'"
              (dblclick)="editElement($event)"
              (blur)="tabTitleBlur($event, tab)"
              >{{ tab.name }}</span
            >
            <div class="tab-nav__left__items__edit-item__actions">
              <ts-button
                type="icon"
                icon="heroicons_outline:trash"
                [iconTooltip]="tabs.length === 1 ? 'Cannot remove last tab' : 'Remove tab'"
                color="basic"
                (click)="removeTab(tab)"
                [disabled]="tabs.length === 1"
              ></ts-button>
            </div>
            <div *cdkDragPreview class="tab-item-drag-preview">
              <mat-icon class="drag-icon">drag_indicator</mat-icon>
              {{ tab.name }}
            </div>
          </div>
        }
      </div>
      <ts-button
        type="icon"
        icon="create_new_folder"
        color="basic"
        class="mr-2"
        iconTooltip="New tab"
        iconColor="gray"
        (click)="addTab()"
      ></ts-button>
      <ts-button
        type="icon"
        icon="fa-plus-square"
        color="basic"
        [matMenuTriggerFor]="addPanelMenu"
        iconTooltip="Add panel"
        iconColor="gray"
      ></ts-button>
    </div>
    <div class="tab-nav__right">
      <ts-button
        type="icon"
        icon="help_outline"
        color="basic"
        iconTooltip="Help"
        [tsOverlayTriggerFor]="infoOverlay"
      ></ts-button>
      <ts-button color="basic" icon="undo" (click)="restore()">Restore</ts-button>
      <ts-button color="primary" class="mr-1" icon="save" (click)="save()">Save</ts-button>
    </div>
  </div>
  <gridster [options]="gridOptions">
    @for (item of currentTab?.layout; track item) {
      <gridster-item [item]="item">
        <div class="panel animate__animated animate__fadeIn animate__fast">
          <div
            class="header"
            appAccountColorBackground
            #backgroundDirective="appAccountColorBackground"
            [colorName]="item.panel.color"
          >
            <div class="header__left cursor-pointer">
              <span
                #panelName
                [class.cursor-text]="panelName.contentEditable == 'true'"
                class="header__left__title"
                (dblclick)="editElement($event)"
                (blur)="panelTitleBlur($event, item.panel)"
                (mousedown)="$event.stopPropagation()"
                [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
                >{{ item.panel.title }}</span
              >
            </div>
            <div class="header__right">
              <span [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'">{{
                panelLabelMap[item.panel.type]
              }}</span>
              <ts-button
                type="icon"
                color="basic"
                iconTooltip="Switch panel type"
                icon="compare_arrows"
                (mousedown)="$event.stopPropagation()"
                class="cursor mr-2"
                [matMenuTriggerFor]="addPanelMenu"
                (click)="switchPanel(item.panel)"
              ></ts-button>
              <ts-button
                type="icon"
                color="basic"
                iconTooltip="Header color"
                icon="ts_palette"
                class="cursor"
                (mousedown)="$event.stopPropagation()"
                [matMenuTriggerFor]="colorMenu"
                (click)="colorMenuOpen(item.panel)"
              ></ts-button>
            </div>
          </div>
          <div class="actions">
            <ts-button
              type="icon"
              icon="heroicons_solid:trash"
              matTooltip="Delete me"
              class="delete-panel-handler"
              (mousedown)="$event.stopPropagation()"
              (click)="onRemovePanel(item.panel)"
              color="basic"
              iconTooltip="Delete panel"
            >
            </ts-button>
          </div>
        </div>
      </gridster-item>
    }
  </gridster>
</div>

<mat-menu #addPanelMenu>
  @for (panel of panels; track $index) {
    @if (panel.type === 'table') {
      <button mat-menu-item [matMenuTriggerFor]="relatedObjectsTable">
        <mat-icon svgIcon="add"></mat-icon>
        <span>{{ panel.title }}</span>
      </button>
    } @else {
      <button mat-menu-item (click)="addPanel(panel)">
        <mat-icon svgIcon="add"></mat-icon>
        <span>{{ panel.title }}</span>
      </button>
    }
    @if (panels.length > 1) {
      <mat-divider></mat-divider>
    }
  }
</mat-menu>

<mat-menu #relatedObjectsTable>
  @for (customObject of customObjects$ | async; track $index) {
    <button mat-menu-item (click)="addRelatedTablePanel(customObject)">
      <mat-icon svgIcon="add"></mat-icon>
      <span>{{ customObject.label }}</span>
    </button>
  }
</mat-menu>

<mat-menu class="mailbox-details-toggle-label-menu-panel" #colorMenu (closed)="colorMenuClose()">
  @for (color of accountColors$ | async; track color) {
    <div mat-menu-item class="gap-2" (click)="selectHeaderColor(color.name)">
      <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
      {{ color.label }}
    </div>
  }
</mat-menu>

<ts-overlay #infoOverlay position="bottom" [transparentBackdrop]="false">
  <div class="help-container">
    <p>
      <ts-icon icon="heroicons_outline:information-circle" color="gray"></ts-icon
      ><span>Double click on any title to edit</span>
    </p>
    <p>
      <ts-icon icon="heroicons_outline:information-circle" color="gray"></ts-icon
      ><span>Click and hold panels to drag</span>
    </p>
    <p>
      <ts-icon icon="heroicons_outline:information-circle" color="gray"></ts-icon
      ><span>Click on an empty tile to add a panel</span>
    </p>
    <p><ts-icon icon="undo" color="gray"></ts-icon><span>Click to restore to initial version</span></p>
    <p><ts-icon icon="save" color="gray"></ts-icon><span>Click to save the changes</span></p>
    <p><ts-icon icon="drag_indicator"></ts-icon><span>Drag to reorder tabs</span></p>
    <p>
      <ts-icon icon="heroicons_outline:trash" color="gray"></ts-icon
      ><span>Click to remove a tab (you cannot remove the last tab)</span>
    </p>
    <p><ts-icon icon="create_new_folder" color="gray"></ts-icon><span>Click to add a tab</span></p>
    <p><ts-icon icon="fa-plus-square" color="gray"></ts-icon><span>Click to add a new panel</span></p>
    <p><ts-icon icon="compare_arrows" color="gray"></ts-icon><span>Click to switch panel type</span></p>
    <p><ts-icon icon="ts_palette" color="gray"></ts-icon><span>Click to choose a header color</span></p>
    <p><ts-icon icon="heroicons_solid:trash" color="gray"></ts-icon><span>Click to remove the panel</span></p>
  </div>
</ts-overlay>
